import React from "react";
import ReactPlayer from "react-player";
import Figure from "./Figure";

const serializers = {
  types: {
    mainImage: Figure,
    vimeo: ({ node }) => (
      <div
        style={{
          paddingTop: "56.25%",
          position: "relative",
          overflow: "hidden",
          background: "black",
        }}
      >
        <ReactPlayer
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: "absolute",
          }}
          url={node.url}
          height="100%"
          width="100%"
          controls={true}
        />
      </div>
    ),
  },
};

export default serializers;
